import { connect } from 'react-redux';
import HomeComponent from './homeComponent';

const Home = connect(
  null,
  null
)(HomeComponent);

export default Home;
